import BaseService from "./BaseService";

export type UsageValueTotals = {
    listeningTimeSavedMs: number;
    messages: number;
    activeChatUsers: number;
    montagesCreated: number;
    activeSearchSubscriptions: number;
    activeFlowSubscriptions: number;
    searchEmailsSent: number;
    flowEmailsSent: number;
};

export type UsageValueChatUserRow = {
    userId: string;
    name: string;
    email: string;
    role?: string | null;
    messages: number;
    listeningTimeSavedMs: number;
    montagesCreated: number;
    lastActive?: string | null;
};

export type UsageValueSearchSubscriptionRow = {
    id: string;
    name?: string | null;
    ownerName?: string | null;
    ownerEmail?: string | null;
    ownerRole?: string | null;
    cadence: string;
    kboAnalysisEnabled: boolean;
    isActive: boolean;
    emailsSent: number;
    lastRun?: string | null;
    nextRun?: string | null;
};

export type UsageValueFlowSubscriptionRow = {
    id: string;
    userName?: string | null;
    userEmail?: string | null;
    role?: string | null;
    cadence: string;
    isActive: boolean;
    emailsSent: number;
    lastRun?: string | null;
    nextRun?: string | null;
};

export type UsageValueTimeSavedBucket = {
    bucketStart: string;
    listeningTimeSavedMs: number;
};

export type UsageValueReport = {
    startDate: string;
    endDate: string;
    previousStartDate: string;
    current: UsageValueTotals;
    previous: UsageValueTotals;
    chatUsers: UsageValueChatUserRow[];
    searchSubscriptions: UsageValueSearchSubscriptionRow[];
    flowSubscriptions: UsageValueFlowSubscriptionRow[];
    seriesBucket: "week" | "month";
    timeSavedSeries: UsageValueTimeSavedBucket[];
};

export class UsageValueService extends BaseService {
    protected urlBase = "api/UsageValue";

    /**
     * Report for [startDate, endDate); both bounds should be day-aligned. Authentizen usage is left
     * out unless includeAuthentizens is set.
     */
    public async getReport(
        startDate: Date,
        endDate: Date,
        includeAuthentizens: boolean,
        abortSignal?: AbortSignal,
    ): Promise<UsageValueReport> {
        return this.get<UsageValueReport>(
            new URLSearchParams({
                startDate: startDate.toISOString(),
                endDate: endDate.toISOString(),
                includeAuthentizens: String(includeAuthentizens),
            }),
            "Report",
            abortSignal,
        );
    }
}
